/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Your_AccountInputs */

const en_profile_your_account = /** @type {(inputs: Profile_Your_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account`)
};

const es_profile_your_account = /** @type {(inputs: Profile_Your_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta`)
};

/**
* | output |
* | --- |
* | "Your account" |
*
* @param {Profile_Your_AccountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_your_account = /** @type {((inputs?: Profile_Your_AccountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Your_AccountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_your_account(inputs)
	return en_profile_your_account(inputs)
});